import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'
import { i18n } from '@fs/zion-locale'

export default function useContributeLinks({
  nonReligiousMode,
  isNonEnCoreLanguage,
  canAddPersonalData,
  isCoreLanguage,
}) {
  const { t } = useTranslation()
  const useLabsLink = useFeatureFlag('frontier_labs_showLabs')
  const updateIndexingLink = useFeatureFlag('home_whatIsIndexing').isOn

  return {
    id: 'involved',
    title: t('nav.involved', 'Ways to Contribute'),
    hidden: !isCoreLanguage,
    subNav: [
      {
        id: 'involved',
        text: t('nav.links.involved.getInvolved', 'Get Involved'),
        url: '/getinvolved/',
        linkName: 'ff_inv_getInvolved',
        dataTestId: 'ff_get_involved',
        isNew: false,
      },
      {
        id: 'indexing',
        text: updateIndexingLink
          ? t('feedback.category.what-is-indexing', 'What is Indexing?')
          : t('feedback.category.indexing', 'Indexing'),
        url: updateIndexingLink ? `/${i18n.language}/indexing` : '/getinvolved/my-opportunities',
        linkName: 'ff_inv_indexing',
        dataTestId: 'ff_indexing',
        isNew: false,
        hidden: nonReligiousMode || !canAddPersonalData,
      },
      {
        id: 'volunteer',
        text: t('nav.help.volunteer', 'Volunteer'),
        url: '/info/volunteer',
        linkName: 'ff_inv_volunteer',
        dataTestId: 'ff_volunteer',
        isNew: false,
        hidden: nonReligiousMode,
      },
      {
        id: 'donate',
        text: t('nav.links.involved.donate', 'Donate'),
        url: 'https://philanthropies.churchofjesuschrist.org/church-general-fund/',
        linkName: 'ff_inv_donate',
        dataTestId: 'ff_donate',
        isNew: false,
        hidden: isNonEnCoreLanguage || nonReligiousMode,
      },
      {
        id: 'labs',
        text: t('nav.links.involved.labs', 'FamilySearch Labs'),
        url: `/${i18n.language}/labs/`,
        linkName: 'ff_inv_labs',
        dataTestId: 'ff_labs',
        isNew: false,
        hidden: !useLabsLink.isOn || !canAddPersonalData || nonReligiousMode,
      },
    ],
  }
}
